export default __webpack_public_path__ + "media/zurb/fonts/heroes_legend-webfont-c5eb9b98cf16b94bc1b9944a04f6b515.woff";